"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.carsRepository = void 0;
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
/**
 * Słownik samochodów służbowych (kilometrówka).
 * Trasy za bramką /admin - dostęp mają ADMIN i ENVI_MANAGER.
 */
exports.carsRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "admin/cars",
        addNewRoute: "admin/car",
        editRoute: "admin/car",
        deleteRoute: "admin/car",
    },
    name: "cars",
});
